// extracted by mini-css-extract-plugin
export default {"Mark":"_checkMark_Mark__M+QoJ"};